import { useEffect, useState } from "react";
import { Checkbox, FormControlLabel, Grid, TextField } from "@material-ui/core";
import FormSelectSearchField from "./form-select-search-field";
import { JobSiteFieldProps } from "../../interface/JobSiteFieldProps";

const JobSiteField = ({
  value,
  label,
  items,
  onChange,
  readOnly,
  className,
}: JobSiteFieldProps) => {
  const validItems = items.filter((i) => !!i);
  const [enterManually, setEnterManually] = useState(false);
  const [savedValue, setSavedValue] = useState("");

  // Auto-detect manual entry: if a value exists but doesn't match any project
  // job site, switch to manual mode (e.g. dispatch user typed a custom value)
  useEffect(() => {
    if (value && validItems.length > 0 && !validItems.includes(value)) {
      setEnterManually(true);
    }
  }, [validItems.length]);

  const options = validItems.map((i) => ({ value: i, label: i }));

  const selectedValue = value ? { value, label: value } : null;

  if (readOnly) {
    return (
      <TextField
        fullWidth
        variant="outlined"
        label={label}
        value={value}
        InputProps={{ readOnly: true }}
        InputLabelProps={{ shrink: !!value }}
        className={className}
      />
    );
  }

  return (
    <>
      {enterManually ? (
        <TextField
          fullWidth
          variant="outlined"
          label={label}
          value={value}
          onChange={(e) => onChange(e.target.value)}
        />
      ) : (
        <FormSelectSearchField
          name="jobSite"
          value={selectedValue}
          options={options}
          onChange={(state: any, action: any) => {
            const act = action?.action ?? action;
            if (act === "clear" || !state) {
              onChange("");
            } else {
              onChange(state.value);
            }
          }}
          placeholder={label}
          isClearable
        />
      )}
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <FormControlLabel
            control={
              <Checkbox
                checked={enterManually}
                onChange={() => {
                  if (!enterManually) {
                    setSavedValue(value);
                    onChange("");
                  } else {
                    onChange(savedValue);
                  }
                  setEnterManually(!enterManually);
                }}
                color="primary"
              />
            }
            label="Enter manually"
          />
        </Grid>
      </Grid>
    </>
  );
};

export default JobSiteField;
